module.exports = __webpack_public_path__ + "img/symbol_8.f59328b9.png";